export default {
  biochemicalTestList: [],
  biochemicalTestSelected: null,
  itemSelected: null,
  bcTestType: null,
  pagination: "",
  count: 0,
};
